import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { DDL } from 'src/app/core-module/models/ddl';
import { CAQuestion } from 'src/app/core-module/models/ExternalAudits/ca-question';

@Component({
    selector: 'app-radio-button',
    templateUrl: './radio-button.component.html',
    styleUrl: './radio-button.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RadioButtonComponent {
  @Input() currentQuestion: CAQuestion = new CAQuestion();
  @Output() currentQuestionChange = new EventEmitter<CAQuestion>();
  @ViewChild('naInput') naInput!: ElementRef;

  public uniqueQuestionID: string = "sortThis"
  public naSelectedID: string = "naID"
  public selectedAnswer:DDL=new DDL();

  constructor() {
    this.setAnswer();
  }

  ngOnChanges() {
    /*this.setDefault()*/

  }
  setAnswer() {
    if (this.currentQuestion != undefined) {
      if (this.currentQuestion.AnswerIDs.length > 0) {
        if (this.currentQuestion.QuestionAnswers.findIndex(x => { return x.ID == this.currentQuestion.AnswerIDs[0] }) != -1) {
          this.currentQuestion.QuestionAnswers.forEach(x => { x.SelectedOption = false; });
          this.currentQuestion.QuestionAnswers.find(y => y.ID == this.currentQuestion.AnswerIDs[0])!.SelectedOption = true;
        };
      }
    }
    if (this.currentQuestion.AllowNA) {
      this.currentQuestion.NASelected = false;
    }

  }
  naAnswer() {
    this.currentQuestion.IsAnswered = true;
    if (!this.currentQuestion.NASelected) {
      this.currentQuestion.AnswerIDs = [];
      this.currentQuestion.QuestionAnswers.forEach(x => x.SelectedOption = false);
    }
  }
  selectNA() {
    if (!this.currentQuestion.NASelected) {
      this.naInput.nativeElement.click();
    }

  }
  updateAnswer(answer: DDL) {

    this.currentQuestion.NASelected = false;
    this.currentQuestion.AnswerIDs = [];
    this.currentQuestion.AnswerIDs.push(answer.ID);
    this.currentQuestion.IsAnswered = true;
    this.setAnswer();
    /*var answerIndex = this.currentQuestion.AnswerIDs.findIndex(x=>x==answer.ID);
    if(answerIndex!=-1){
      this.currentQuestion.AnswerIDs.splice(answerIndex,1);
    }else{
      this.currentQuestion.AnswerIDs.push(answer.ID);
    }*/
  }

  /*setDefault() {
    if(!this.currentQuestion.CompletionInfo.QuestionAnswered){
        if (this.currentQuestion.QuestionAnswers.some(e => e.IsDefault)) {
        this.currentQuestion.QuestionAnswers.find(f => f.IsDefault)!.Selected = true;
      }
    }else{
      this.currentQuestion.QuestionAnswers.forEach(e=>{
        if(this.currentQuestion.CompletionInfo.Answer == e.QuestionAnswerID){
          e.Selected = true;
        }else{
          e.Selected = false;
        }
      })
     
    }
    this.performUpdate();
  }*/
  /*updateAnswer(currentAnswer: CAQuestionAnswer) {
    this.currentQuestion.QuestionAnswers.forEach(e => e.Selected = false);
    currentAnswer.Selected = true;
    this.currentQuestion.CompletionInfo.Answer = currentAnswer.QuestionAnswerID;
    this.currentQuestion.CompletionInfo.QuestionAnswered = true;
    this.performUpdate();
  }
  performUpdate() {
    this.currentQuestionChange.emit(this.currentQuestion);
  }

  resetQuestion(){
    this.currentQuestion.QuestionAnswers.forEach(e => e.Selected = false);
    this.currentQuestion.CompletionInfo.Answer = null;
    this.currentQuestion.CompletionInfo.QuestionAnswered = false;
    this.performUpdate();
  }*/

  resetQuestion() { }
}
